import { TaskManagerState } from "types";
import { DEFAULT_DRAWER_STATE } from "constants/index";

export const initialState: TaskManagerState = {
  groups: {
    data: [],
    isLoading: false,
  },
  pendingTasks: {
    data: [],
    isLoading: false,
  },
  tasks: {
    data: [],
    isLoading: false,
  },
  drawerInfo: DEFAULT_DRAWER_STATE,
  group: {
    data: null,
    isLoading: false,
  },
  taskHistory: {
    data: [],
    isLoading: false,
  },
  instanceHistory: {
    data: [],
    isLoading: false,
  },
  taskInstance: {
    data: null,
    isLoading: false,
  },
  operationsHandlers: {
    data: [],
    isLoading: false,
  },
  users: {
    data: [],
    isLoading: false,
  },
  task: {
    data: null,
    isSaving: false,
  },
  newEmail: {
    data: null,
    isSending: false,
  },
  taskRun: {
    data: null,
    isRunning: false,
  },
  taskDelete: {
    data: null,
    isDeleting: false,
  },
  scripts: {
    data: [],
    isLoading: false,
  },
};
